import SelectedVersions from 'src/versions/SelectedVersions';
import Version from './Version';
import VersionGroup from './VersionGroup';

export default class VersionStore {

    public constructor(private readonly versions: Version[]) {
    }

    public getVersion(index: number): Version {
        const version = this.versions.find(v => v.getIndex() === index);
        if (version === undefined) {
            throw new Error('Version not found: ' + index);
        }
        return version;
    }

    public getVersionByCode(code: string): Version {
        const codeLower = code.toLowerCase();
        const version = this.versions.find(v => v.getCode().toLowerCase() === codeLower);
        if (version === undefined) {
            throw new Error('Version not found: ' + code);
        }
        return version;
    }

    public getVersions(indexes: number[] | SelectedVersions): Version[] {
        const indexArray = indexes instanceof SelectedVersions ? indexes.getSelected() : indexes;
        return this.versions.filter(version => indexArray.indexOf(version.getIndex()) !== -1);
    }

    public getVersionGroup(group: VersionGroup): Version[] {
        return this.versions.filter(version => version.getGroup() === group);
    }

    public getAllVersions(): Version[] {
        return this.versions;
    }

    public getVersionCount(): number {
        return this.versions.length;
    }
}
